import { render, staticRenderFns } from "./card-detail.vue?vue&type=template&id=aac75a3c&"
import script from "./card-detail.vue?vue&type=script&lang=ts&"
export * from "./card-detail.vue?vue&type=script&lang=ts&"
import style0 from "./card-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports